import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guard/auth.guard';
import { isActiveSessionGuard } from '@core/guard/IsActiveSession-guard';
import { verifyTokenResolver } from '@core/resolvers/verify-token-resolver';
import { isOnlineGuard } from '@page/no-internet/IsOnline-guard';

export const routes: Routes = [
  {
    path: 'location-required',
    loadComponent: () => import('./core/location-required/location-required.component')
  },
  {
    path: 'verify',
    resolve: { verified: verifyTokenResolver },
    children: [], // no component needed
  },
  {
    path: 'no-internet',
    canActivate: [isOnlineGuard],
    loadComponent: () => import('./pages/no-internet/no-internet.component')
  },
  {
    path: '',
    redirectTo: 'products',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    data: { auth: true },
    loadChildren: () => import('./pages/auth/auth-routing.routes')
  },
  {
    path: '',
    canActivate: [isActiveSessionGuard],
    loadChildren: () => import('./pages/pages-routing.routes')
  },

  {
    path: '**', loadComponent: () => import('./pages/no-page-found/no-page-found.component').then(c => c.NoPageFoundComponent)
  },
];
